import SuperAvatar from './SuperAvatar';

export default SuperAvatar;
